import ICONS from "../../../../../assets/Icons";
import {
  GlobalConfiguration,
  IntervalConfiguration,
} from "../../../../../utils/configurationProvider";
import TEXT from "../../../../../utils/globalText";
import AssignLabels from "../../../../_utils/AccountCreationComponents/AssignLabels";
import PrimaryButton from "../../../../_utils/CommonButtons/PrimaryButton";
import SVGComponent from "../../../../_utils/SVGComponent";
import NameFieldCard from "../../../../_utils/TransactionCommonComponents/NameFieldCard";
import RemitAccountViewAllPopup from "../../RemitAccountViewAllPopup";
import ConfirmBtnAccCreation from "../../../../_utils/AccountCreationComponents/ConfirmBtnAccCreation";
import { useEffect } from "react";

const RemitAccountStepName = ({
  accountPayLoad,
  setAccountPayLoad,
  setLabelpopup,
  isDuplicate,
  setIsDuplicate,
  openSimilarPopup,
  setOpenSimilarPopup,
  duplicateLoading,
  checkDuplicateAccount,
  isRemitterAccountLoading,
  isDuplicateConfirmed,
  setIsDuplicateConfirmed,
  hasAnimatedDuplicate,
  setHasAnimatedDuplicate,
}) => {
  useEffect(() => {
    if (isDuplicate && !hasAnimatedDuplicate) {
      const timer = setTimeout(() => {
        setHasAnimatedDuplicate(true);
      }, IntervalConfiguration?.intervalSmaller);
      return () => clearTimeout(timer);
    }
  }, [isDuplicate, hasAnimatedDuplicate]);
  return (
    <>
      {openSimilarPopup && (
        <RemitAccountViewAllPopup
          remName={accountPayLoad?.remitterAccountName.trim()}
          type={"RemitterAcc"}
          propType={"similerAccount"}
          headerTitle={"Similar accounts"}
          headersubtext={"The following accounts have similar names."}
          closePopup={setOpenSimilarPopup}
          onCardNavigate
        />
      )}

      {/* {duplicateLoading ? (
        <>
          <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-fixed-ui bg-PopUp-BackDrop opacity-dark-opacity">
            <div>
              <Loader type={"bulk_upload"} />
              <p className=" font-semibold text-font-lg text-text-primary">
                Validating the data
              </p>
            </div>
          </div>
        </>
      ) : ( */}
      <div className="w-width-full max-w-tab-width-normal flex flex-col gap-y-gap-md">
        <div className="flex flex-col Qlg:flex-row lg:gap-gap-xl gap-gap-md Qmd:justify-between py-padding-md Qmd:py-padding-base px-padding-md Qlg:px-padding-base">
          <div className="flex flex-col gap-gap-md w-width-full lg:w-width-md lg:max-w-[var(--create-box-width)]">
            {/* {isDuplicate && (
              <div className="flex items-start gap-gap-sm bg-emphasis rounded-border-radius-md p-padding-md">
                <img
                  src={ICONS?.ERROR_WITH_WHITE_CIRCLE}
                  alt="error"
                  className="w-icon-md h-icon-md flex-shrink-0"
                />
                <p className="text-font-xs text-text-primary">
                  Clicking "Next" will continue account creation with a similar
                  name.
                </p>
              </div>
            )} */}
            <NameFieldCard
              title="Account Name"
              placeholder="Account name"
              fieldName="remitter_name"
              value={accountPayLoad.remitterAccountName}
              mode="strict"
              minLength={GlobalConfiguration?.lengthCheckThree}
              onChange={(val) => {
                const cleaned = val
                  .trimStart()
                  .slice(
                    GlobalConfiguration.lengthCheckZero,
                    GlobalConfiguration.inputValidationLength,
                  );

                const normalize = (str) =>
                  (str || "").replace(/\s+/g, "").toLowerCase();

                const previousNormalized = normalize(
                  accountPayLoad.remitterAccountName,
                );
                const newNormalized = normalize(cleaned);

                setAccountPayLoad({
                  ...accountPayLoad,
                  remitterAccountName: cleaned,
                });

                if (newNormalized !== previousNormalized) {
                  setIsDuplicate(null);
                  setIsDuplicateConfirmed(false);
                  setOpenSimilarPopup(false);
                }
              }}
              note="Note: Minimum 3 characters required."
            />
          </div>

          <div className="w-width-full lg:w-width-md lg:max-w-[var(--create-box-width)]">
            {isDuplicate && (
              <>
                <div style={{ overflow: "hidden" }}>
                  <div
                    className={
                      hasAnimatedDuplicate ? "" : "animate-slideInFromRight"
                    }
                  >
                    <ConfirmBtnAccCreation
                      type="remitter"
                      status={isDuplicate}
                      isConfirmed={isDuplicateConfirmed}
                      handleClick={() => {
                        setIsDuplicateConfirmed(true);
                      }}
                      subtext={
                        "Confirm and click ‘Next’ to proceed with creating a new account with a similar name."
                      }
                    />
                  </div>
                </div>
              </>
            )}
            <div className="flex flex-col gap-gap-md">
              <div
                className={`flex gap-gap-sm w-full rounded-border-radius-md bg-primary-card p-padding-md ${isDuplicate && "cursor-pointer global-hover-white z-z-index-content relative"}`}
                onClick={() => {
                  if (isDuplicate) {
                    setOpenSimilarPopup(true);
                  }
                }}
              >
                {isDuplicate && (
                  <div className="flex-shrink-0">
                    <img
                      src={ICONS?.ALERT}
                      className="w-icon-md h-icon-md"
                      alt="Alert"
                    />
                  </div>
                )}
                <div className="flex flex-col gap-gap-sm w-width-full">
                  <div className="flex flex-col gap-gap-sm w-width-full">
                    <div className="w-full h-auto font-semibold text-base text-text-primary flex justify-between items-center">
                      {isDuplicate === null ? (
                        <h1>Similar Accounts</h1>
                      ) : isDuplicate === false ? (
                        <h1>No Similar Accounts Found</h1>
                      ) : (
                        <h1>Similar Accounts Found</h1>
                      )}

                      {isDuplicate && (
                        <SVGComponent
                          url={ICONS.ARROW_RIGHT_WHITE}
                          height={"var(--icon-sm)"}
                          width={"var(--icon-sm)"}
                          color={"var(--text-primary)"}
                        />
                      )}
                    </div>
                    {!duplicateLoading && (
                      <ul
                        className={`w-full h-auto font-normal text-xs text-text-secondary flex flex-col gap-gap-sm ${isDuplicate === true && "list-disc pl-padding-md"}`}
                      >
                        <li>
                          {isDuplicate === null
                            ? 'Click "Check" to view similar accounts.'
                            : isDuplicate === false
                              ? "There are no existing accounts that are similar to the provided name."
                              : "Review existing accounts that are similar to the provided name before creating this account."}
                        </li>
                      </ul>
                    )}
                  </div>
                  {isDuplicate === null && (
                    <div className="w-width-full">
                      <PrimaryButton
                        btnText="Check"
                        btnType="button"
                        hoverOption="white"
                        handleFunction={() => {
                          if (
                            accountPayLoad?.remitterAccountName
                              .trim()
                              .replace(/\s+/g, "").length >=
                            GlobalConfiguration.lengthCheckThree
                          ) {
                            checkDuplicateAccount();
                          }
                        }}
                        enabledTextColor={"var(--text-primary)"}
                        isDisabled={
                          accountPayLoad?.remitterAccountName
                            .trim()
                            .replace(/\s+/g, "").length <
                          GlobalConfiguration.lengthCheckThree
                        }
                        disabledTextColor={"var(--text-primary)"}
                        enabledBgColor={"var(--positive-act)"}
                        disabledBgColor={"var(--text-disabled)"}
                        inActiveVariantNeeded
                        fullWidthRequired
                        isFillNeeded
                        isLoading={isRemitterAccountLoading && duplicateLoading}
                        isLoaderNeeded
                      />
                    </div>
                  )}
                </div>
              </div>
              <AssignLabels
                setLabelpopup={setLabelpopup}
                labels={accountPayLoad?.labels}
                subText1={TEXT?.LABELS_ACCOUNT_USAGE_NOTE}
                isOptional={true}
              />
            </div>
          </div>
        </div>
      </div>
      {/* )} */}
    </>
  );
};

export default RemitAccountStepName;
